// Form translations - English
export const formsEn = {
  validation: {
    required: 'This field is required',
    invalidEmail: 'Invalid email address',
    invalidPhone: 'Invalid phone number',
    minLength: 'Minimum {min} characters',
    maxLength: 'Maximum {max} characters',
  },

  fields: {
    name: 'Name',
    fullName: 'Full name',
    email: 'Email',
    phone: 'Phone',
    message: 'Message',
    subject: 'Subject',
    company: 'Company',
    address: 'Address',
  },

  actions: {
    submit: 'Submit',
    reset: 'Reset',
    clear: 'Clear',
    save: 'Save',
    cancel: 'Cancel',
  },

  messages: {
    success: 'Form submitted successfully',
    error: 'Error submitting form',
    processing: 'Processing...',
  },
};



